import React, { useEffect, useState, useRef, printRef } from "react";
import axios from "axios";
import { Container, Row, Col, Card, Button, Form, Modal, Tooltip, Spinner } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import Select from "react-select";
import DataTable from "react-data-table-component";

import FeeParticulars from "./FeeParticulars";
import { useFeeModuleAccess } from "../hooks/useFeeModuleAccess";
import PrintableReceipt from "../../printreceipt";
import ReactDOMServer from "react-dom/server";
import { MdInfoOutline } from "react-icons/md";
import { BsPatchCheckFill } from "react-icons/bs";



const AddFeeReceipts = () => {
  const userData = sessionStorage.getItem('user');
  const userObj = JSON.parse(userData);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const [classes, setClasses] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sections, setSections] = useState([]);
  const [students, setStudents] = useState([]);
  const [filterdStudents, setFilterdStudents] = useState([]);
  const [selectedFeeCategory, setSelectedFeeCategory] = useState("");
  const [feeschedule, setFeeschedule] = useState([]);
  const [studentFeeSchedule, setStudentFeeSchedule] = useState([]);
  const currentUserRole = userObj.role_name?.trim();
  const [admissionOptions, setAdmissionOptions] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [selectedAdmission, setSelectedAdmission] = useState(null);
  const [isClassChangedManually, setIsClassChangedManually] = useState(false);
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [receiptDetails, setReceiptDetails] = useState([]);
  const [discountReport, setDiscountReport] = useState({
    expected_fee: 0,
    discount: 0,
    total_fee: 0
  });

  const { canWrite } = useFeeModuleAccess(currentUserRole);

  const [receiptData, setReceiptData] = useState({
    amountDetails: [],
    grandTotal: "",
  });
  const receiptColumns = [
    {
      name: "Receipt No",
      selector: (row) => row.fee_receipt_no,
      sortable: true,
      cell: (row) => <span>{row.fee_receipt_no}</span>,
    },
    {
      name: "Receipt Date",
      selector: (row) => row.reciept_date,
      sortable: true,
      cell: (row) => <span>{row.reciept_date}</span>,
    },
    {
      name: "Mode",
      selector: (row) => row.mode,
      sortable: true,
      cell: (row) => <span>{row.mode}</span>,
    },
    {
      name: "Paid Amount",
      selector: (row) => row.amount_paid,
      sortable: true,
      cell: (row) => <span>{row.amount_paid}</span>,
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
      sortable: true,
      cell: (row) => <span>{row.remarks}</span>,
    },
  ];


const [selectedStudent, setSelectedStudent] = useState(null);
  const fetchNotifications = async () => {
    try {
      const response = await axios.post(`${baseUrl}/notifications/`, {
        action: "READ",
        school_id: userObj.school_id
      });

      const data = Array.isArray(response.data) ? response.data : [];
      setNotifications(data);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }

  };

  const [form, setForm] = useState({
    class_id: null,
    class_name: "",
    school_id: userObj.school_id || 0,
    academic_year_id: userObj.academic_year_id || 0,
    student_id: "",
    student_name: "",
    section_id: "",
    reciept_date: "",
    admission_number: "",
    receipt_no: "",
    father_name: "",
    mode: "",
    transation_no: "",
    fee_schedule_id: "",
    schedule_name: "",
    section_name: "",
    contact_no: "",
    remarks: "",
  });

  useEffect(() => {
    fetchClasses();
    fetchTerms();
    // fetchAllStudents();
    fetchNotifications();
  }, []);

  // const fetchAllStudents = async () => {
  //   try {
  //     const response = await axios.post(baseUrl + "/students/", {
  //       action: "FILTER",
  //       school_id: userObj.school_id,
  //       academic_year_id: userObj.academic_year_id
  //     });

  //     const data = Array.isArray(response.data) ? response.data : [];

  //     const filtered = data.filter(
  //       item => item.status?.toLowerCase() === 'active' &&
  //         String(item.academic_year_id) === String(userObj.academic_year_id)
  //     );

  //     setFilterdStudents(filtered);

  //     const admissionList = filtered.map(student => ({
  //       value: student.student_id,
  //       label: student.admission_number,
  //     }));

  //     const studentNameList = filtered.map(student => ({
  //       value: student.student_id,
  //       label: `${student.student_first_name} ${student.student_last_name} (${student.admission_number})`,
  //       admission_number: student.admission_number,
  //       student_first_name: student.student_first_name,
  //       student_last_name: student.student_last_name,
  //     }));

  //     setAdmissionOptions(admissionList);
  //     setStudents(studentNameList);
  //   } catch (error) {
  //     console.error("Error fetching all students initially:", error);
  //   }
  // };
  // call only when user types
  const fetchStudentsByQuery = async (q, limit = 50) => {
    try {
      const res = await axios.post(`${baseUrl}/studentdropdown`, {
        p_query: q,
        p_school_id: userObj.school_id,
        p_academic_year_id: userObj.academic_year_id,
        p_limit: limit
      });

      const rows = Array.isArray(res.data) ? res.data : (res.data?.data || []);


      setFilterdStudents(rows);

      const admissionList = rows.map(s => ({
        value: s.student_id,
        label: s.admission_number
      }));

      const studentNameList = rows.map(s => ({
        value: s.student_id,
        label: `${s.student_first_name ?? ""} ${s.student_last_name ?? ""} (${s.admission_number ?? ""})`,
        admission_number: s.admission_number,
        student_first_name: s.student_first_name,
        student_last_name: s.student_last_name
      }));

      setAdmissionOptions(admissionList);
      setStudents(studentNameList);         
      return studentNameList;
    } catch (e) {
      console.error("studentdropdown error:", e);
      setAdmissionOptions([]);
      setStudents([]);
      return [];
    }
  };


const handlePrint = (updatedSchedule = studentFeeSchedule, printForm = form) => {
  const printableHTML = ReactDOMServer.renderToString(
    <PrintableReceipt
      form={printForm}
      receiptData={receiptData}
      studentFeeSchedule={updatedSchedule}
    />
  );

  const printWindow = window.open("", "_blank", "width=800,height=600");
  printWindow.document.write(`${printableHTML}`);
  printWindow.focus();
  printWindow.print();
  printWindow.document.close();
  printWindow.close();
};

  const fetchClasses = async () => {
    try {
      const response = await axios.post(baseUrl + "/classes/", {
        action: "READ",
        school_id: userObj.school_id
      });

      const filterData = Array.isArray(response.data) ? response.data : [];

      const filteredClasses = filterData.filter(
        item => item.is_active?.toLowerCase() === 'active'
      );

      setClasses(filteredClasses)
    }
    catch (error) {
      console.error("Error fetching academic data:", error);
    }
  };
  useEffect(() => {
    if (isClassChangedManually) {
      fetchSections(form.class_id || 0);
      setForm(prevForm => ({
        ...prevForm,
        section_id: "",
      }));
    }

    setReceiptData((prevData) => ({
      ...prevData,
      amountDetails: [],
      grandTotal: 0,
    }));

    setForm(prevForm => ({
      ...prevForm,
      student_id: "",
      student_name: "",
      admission_number: "",
      receipt_no: "",
      father_name: "",
      mode: "",
      transation_no: "",
      fee_schedule_id: "",
      schedule_name: "",
      section_name: "",
      contact_no: "",
      remarks: "",
    }));
  }, [form.class_id]);


  const fetchSections = async (class_id) => {
    try {
      const response = await axios.post(baseUrl + "/Sections/", {
        action: "DROPDOWNREAD",
        school_id: userObj.school_id,
        class_id: class_id,
        academic_year_id: userObj.academic_year_id
      });
      const filterData = Array.isArray(response.data) ? response.data : [];

      const filteredClasses = filterData.filter(
        item => item.is_active?.toLowerCase() === 'active'
      );
      setSections(filteredClasses);
    }
    catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        const errorMessage = data.error || data.message || "Unexpected error occurred";
        if (status === 404) {
          setSections([]);
        }
      } else {
        console.error("Error fetching section:", error);
      }
    }
  };

  const fetchTerms = async () => {
    try {
      const response = await axios.post(baseUrl + "/feeschedule/", {
        action: "READ",
        school_id: userObj.school_id,
        academic_year_id: userObj.academic_year_id
      });

      const data = response.data || [];

      const filterData = Array.isArray(response.data) ? response.data : [];

      const filteredTerms = filterData
        .filter(item => item.status?.toLowerCase() === 'active')
        .sort((a, b) => a.schedule_name.localeCompare(b.schedule_name));

      setFeeschedule(filteredTerms);
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };
  const fetchDiscountReport = async () => {
    try {
      const response = await axios.post(baseUrl + "/getsinglestudentdiscount/", {
        school_id: userObj.school_id,
        academic_year_id: userObj.academic_year_id,
        class_id: form.class_id,        // assuming you have this in `form`
        section_id: form.section_id,    // assuming you have this in `form`
        admission_number: form.admission_number,
        student_id: form.student_id
      });

      const data = response.data;

      if (data && typeof data === 'object') {
        setDiscountReport(data);
      } else {
        setDiscountReport({
          expected_fee: 0,
          discount: 0,
          total_fee: 0,
        });
      }
    } catch (error) {
      console.error("Error fetching discount report:", error);
    }
  };


  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];

    setReceiptData((prevData) => ({
      ...prevData,
      amountDetails: [],
      grandTotal: 0,
    }));

    setForm(prevForm => ({
      ...prevForm,
      student_id: "",
      student_name: "",
      reciept_date: today,
      admission_number: "",
      receipt_no: "",
      father_name: "",
      mode: "",
      transation_no: "",
      fee_schedule_id: "",
      schedule_name: "",
      section_name: "",
      contact_no: "",
      remarks: "",
    }));

    // ✅ Only call fetchStudents if class changed manually and flag is true
    if (isClassChangedManually && form.class_id && form.section_id) {
      fetchStudents(form.class_id, form.section_id);
    }
  }, [form.class_id, form.section_id]);


  const fetchStudents = async (class_id, section_id) => {
    try {
      const response = await axios.post(baseUrl + "/students/", {
        action: "READ",
        school_id: userObj.school_id
      });
      const filterData = Array.isArray(response.data) ? response.data : [];
      console.log("class_id:,section_id:", class_id, section_id);
      const filteredStudents = filterData.filter(
        item => item.status?.toLowerCase() === 'active'
          && String(item.class_id) === class_id
          && String(item.section_id) === section_id
          && String(item.academic_year_id) === userObj.academic_year_id
      );
      console.log("filteredStudents:", filteredStudents);
      setFilterdStudents(filteredStudents);

      const options = filteredStudents.map((student) => ({
        value: student.student_id,
        label: `${student.student_first_name} ${student.student_last_name} (${student.admission_number})`,
        admission_number: student.admission_number,
        student_first_name: student.student_first_name,
        student_last_name: student.student_last_name,
      }));


      const admissionList = filteredStudents.map((student) => ({
        value: student.student_id,
        label: student.admission_number,
      }));

      setStudents(options);
      setAdmissionOptions(admissionList);
    }
    catch (error) {
      console.error("Error fetching students:", error);
    }
  };
  useEffect(() => {
    const filteredStudents = filterdStudents.filter(
      item => item.student_id === form.student_id
    );

    if (filteredStudents.length > 0) {
      setForm(prevForm => ({
        ...prevForm,
        admission_number: filteredStudents[0].admission_number || "",
        student_name: `${filteredStudents[0]?.student_first_name || ""} ${filteredStudents[0]?.student_last_name || ""}`.trim(),
        father_name: `${filteredStudents[0]?.father_firstname || ""} ${filteredStudents[0]?.father_surname || ""}`.trim(),
        class_name: filteredStudents[0].class_name || "",
        section_name: `${filteredStudents[0]?.class_name || ""} & ${filteredStudents[0]?.section_name || ""}`,
        contact_no: filteredStudents[0].father_phone_number || "",
      }));
    } else {
      setForm(prevForm => ({
        ...prevForm,
        admission_number: "",
        student_name: "",
        father_name: "",
        class_name: "",
        section_name: "",
        contact_no: "",
      }));
      setReceiptData((prevData) => ({
        ...prevData,
        amountDetails: [],
        grandTotal: 0,
      }));
    }

    if (form.student_id) {
      fetchFeesItems();

    }

  }, [form.student_id, filterdStudents]);
  useEffect(() => {
    if (form.student_id && form.fee_schedule_id && form.schedule_name) {
      fetchFeesItems();
    }
  }, [form.student_id, form.fee_schedule_id, form.schedule_name]);

  const fetchFeesItems = async () => {
    try {
      const response = await axios.post(baseUrl + "/getrecieptsfeeitems/", {
        school_id: userObj.school_id,
        academic_year_id: userObj.academic_year_id,
        student_id: form.student_id,
        class_id: form.class_id || 0
      });

      let data = Array.isArray(response.data) ? response.data : [];

      data = data.map(item => ({
        ...item,
        fee_category_name: item.fee_category_name || "Onetime Fee"
      }));
      const receiptNo = data.length > 0 && data[0].receipt_no ? data[0].receipt_no : "";
      setForm(prevForm => ({
        ...prevForm,
        receipt_no: receiptNo
      }));
      // ✅ Remove the conditional filtering logic
      // Show all fee items
      setReceiptData({
        amountDetails: data,
        grandTotal: data.reduce((sum, item) => sum + (Number(item.amount) || 0), 0),
      });
    } catch (error) {
      console.error("Error fetching amount details:", error);
      setReceiptData({
        amountDetails: [],
        grandTotal: 0,
      });
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    if (id === "fee_schedule_id") {
      const selectedSchedule = feeschedule.find(
        (item) => String(item.fee_schedule_id) === value
      );

      setForm((prevForm) => ({
        ...prevForm,
        fee_schedule_id: value,
        schedule_name: selectedSchedule?.schedule_name || ""
      }));
    } else {
      setForm((prevForm) => ({
        ...prevForm,
        [id]: value,
      }));
    }
  };
  const typingTimer = useRef();
  const handleStudentTyping = (inputValue, { action }) => {
    if (action !== "input-change") return inputValue; 
    clearTimeout(typingTimer.current);
    const q = (inputValue || "").trim();

    typingTimer.current = setTimeout(() => {
      if (q.length >= 3) {
        fetchStudentsByQuery(q, 50);
      } else {
        setStudents([]);
      }
    }, 300);

    return inputValue; // react-select expects you to return the string
  };

  // 4) Selection handler for react-select (sets all related form fields)
  const handleStudentSelect = (opt) => {
    setSelectedStudent(opt || null);
    setForm((prev) => ({
      ...prev,
      student_id: opt?.value || "",
      admission_number: opt?.admission_number || "",
      student_name: opt?.raw
        ? `${opt.raw.student_first_name ?? ""} ${opt.raw.student_last_name ?? ""}`.trim()
        : "",
    }));
  };
 const sendReceiptNotification = async (receiptNo) => {
  try {
    const notificationTemplates = notifications.filter(
      n => n.notification_type?.toUpperCase() === "R"
    );

    if (!notificationTemplates.length) {
      console.warn("No 'R' type notification templates found.");
      return;
    }

    const template = notificationTemplates[0];
    const rawMessage = template.description || template.notification_message;
    const title = template.notification_title || "Fee Receipt Notification";

    if (!rawMessage) {
      console.warn("No message content found in template:", template);
      return;
    }

    const amountPaid = receiptData.amountDetails.reduce(
      (sum, item) => sum + (parseFloat(item.amount) || 0),
      0
    );

    const replacedMessage = rawMessage
      .replace(/\[Amount\]/g, `${amountPaid}`)
      .replace(/\[Student Name\]/g, form.student_name || "")
      .replace(/\[ Receipt No\]/g, receiptNo || "")
      .replace(/\[Receipt No\]/g, receiptNo || "");

    const student = filterdStudents.find(
      std => String(std.student_id) === String(form.student_id)
    );

    const user_id = student?.father_user_id || student?.mother_user_id || null;

    if (!user_id) {
      console.warn("No user_id found for student:", form.student_id);
      return;
    }

    const payload = {
      action: "CREATE",
      sent_notification_id: 0,
      user_id,
      group_id: null,
      ref_id: template.notification_id,
      school_id: userObj.school_id,
      status: "A",
      ref_type: "R",
      createdby: userObj.user_id,
      lastmodifiedby: userObj.user_id,
      title,
      message: replacedMessage
    };

    console.log("Sending notification payload:", payload);

    const response = await axios.post(
      `${baseUrl}/sentnotificationsforfeereceipt/`,
      payload
    );

    console.log("Notification sent successfully:", response.data);
  } catch (err) {
    console.error("Failed to send notification:", err.response?.data || err.message || err);
  }
};
  const handleAmountChange = (index, newValue) => {
    const updatedAmountDetails = [...receiptData.amountDetails];
    updatedAmountDetails[index].amount = newValue;

    const newGrandTotal = updatedAmountDetails.reduce((total, item) => {
      return total + (parseFloat(item.amount) || 0);
    }, 0);

    setReceiptData((prevData) => ({
      ...prevData,
      amountDetails: updatedAmountDetails,
      grandTotal: newGrandTotal.toString(),
    }));
  };
  useEffect(() => {
    if (!form.student_id) {
      setDiscountReport([]);
    } else {
      fetchDiscountReport();
    }
  }, [form.student_id]);

  const fetchStudentFeeScheduleAfterSubmit = async (student_id) => {
    try {
      const response = await axios.get(baseUrl + "/main/getstudentfeedetail", {
        params: {
          _school_id: userObj.school_id,
          _academic_year_id: userObj.academic_year_id,
          _student_id: student_id,
        user_id:userObj.user_id
        }
      });

      return response.data?.[0]?.getstudentfeedetail?.schedules || [];
    } catch (error) {
      console.error("Error fetching updated schedule after submit:", error);
      return [];
    }
  };

  const resetFormToInitial = () => {
    const today = new Date().toISOString().split("T")[0];

    setIsClassChangedManually(false);
    setSections([]);
    setStudents([]);
    setAdmissionOptions([]);
    setFilterdStudents([]);
    setStudentFeeSchedule([]);
    setReceiptDetails([]);
    setDiscountReport({
      expected_fee: 0,
      discount: 0,
      total_fee: 0
    });

    setForm({
      class_id: null,
      class_name: "",
      school_id: userObj.school_id || 0,
      academic_year_id: userObj.academic_year_id || 0,
      student_id: "",
      student_name: "",
      section_id: "",
      reciept_date: today,
      admission_number: "",
      receipt_no: "",
      father_name: "",
      mode: "",
      transation_no: "",
      fee_schedule_id: "",
      schedule_name: "",
      section_name: "",
      contact_no: "",
      remarks: "",
    });

    setReceiptData({
      amountDetails: [],
      grandTotal: "",
    });
  };

const handleSubmit = async (event, shouldPrint = false) => {
  event.preventDefault();
  if (isSubmitting) return;
  setIsSubmitting(true);

  const submissionData = receiptData.amountDetails.map(item => ({
    action: "CREATE",
    fees_reciepts_id: 0,
    amount_paid: item.amount ? item.amount : 0,
    school_id: userObj.school_id || 0,
    mode: form.mode,
    remarks: form.remarks,
    receipt_date: form.reciept_date,
    fee_receipt_no: "",
    fees_item_id: item.fees_item_id,
    class_id: form.class_id,
    academic_year_id: userObj.academic_year_id || 0,
    student_id: form.student_id,
    createdby: userObj.user_id,
    lastmodifiedby: userObj.user_id,
  }));

  try {
    const response = await axios.post(baseUrl + "/insertfeereciepts/bulk/", submissionData, {
      headers: { "Content-Type": "application/json" },
    });

    setIsSubmitting(false);
    toast.success("Records Added Successfully");

    const receiptNos = response?.data?.details || [];
    const newReceiptNo = receiptNos[0] || "";
    setForm(prev => ({ ...prev, receipt_no: newReceiptNo }));

    const formForPrint = { ...form, receipt_no: newReceiptNo };

    await sendReceiptNotification(newReceiptNo);

    const updatedSchedule = await fetchStudentFeeScheduleAfterSubmit(form.student_id);

    handlePrint(updatedSchedule, formForPrint);

    resetFormToInitial();

    setReceiptData({
      amountDetails: [],
      grandTotal: 0,
    });

    setForm({
      class_id: null,
      class_name: "",
      student_id: "",
      student_name: "",
      section_id: "",
      reciept_date: "",
      admission_number: "",
      receipt_no: "",
      father_name: "",
      mode: "",
      transation_no: "",
      fee_schedule_id: "",
      schedule_name: "",
      section_name: "",
      contact_no: "",
      remarks: "",
    });

    return true;
  } catch (error) {
    console.error("There was an error submitting:", error);
    setIsSubmitting(false);
    return false;
  }
};
  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    setForm((prevForm) => ({
      ...prevForm,
      reciept_date: today,
    }));
  }, []);
  useEffect(() => {
    if (form.student_id) {
      fetchStudentFeeSchedule(form.student_id);
    } else {
      setStudentFeeSchedule([]);
    }
  }, [form.student_id]);
  const fetchStudentFeeSchedule = async (student_id) => {
    try {
      const response = await axios.get(baseUrl + "/main/getstudentfeedetail", {
        params: {
          _school_id: userObj.school_id,
          _academic_year_id: userObj.academic_year_id,
          _student_id: student_id,
          user_id:userObj.user_id
        }
      });

      const scheduleData = response.data?.[0]?.getstudentfeedetail?.schedules || [];
      setStudentFeeSchedule(scheduleData);
    } catch (error) {
      console.error("Error fetching fee schedule:", error);
      setStudentFeeSchedule([]);
    }
  };
  const totalBalance = studentFeeSchedule.reduce(
    (sum, item) => sum + (parseFloat(item.balance_amount_to_be_paid) || 0),
    0
  );

  const fetchReceiptDetails = async () => {
    try {
      const res = await axios.post(baseUrl + "/getfeereciepts/", {
        school_id: userObj.school_id,
        academic_year_id: userObj.academic_year_id,
        student_id: form.student_id,
      });
      setReceiptDetails(res.data || []);
      console.log(receiptDetails);

    } catch (err) {
      console.error("Error loading receipt details:", err);
    }
  };
  return (
  
        <div className='' style={{ maxHeight: 'calc(100vh - 100px)', overflowY: 'auto', padding: '10px' }}>
          <ToastContainer />
          <Container fluid>
            <Card>
              <Card.Body>
                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col xs={12}>
                      <h6 className='commonSectionTitle'>Fee Receipts Details</h6>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={6} lg={3} xxl={3}>
                      <div className='commonInput'>
                        <Form.Group controlId="combined_name">
                          <Form.Label>Class Name</Form.Label>
                          <Form.Select
                            // required
                            id="class_id"
                            value={form.class_id}
                            onChange={(e) => {
                              handleInputChange(e);
                              setIsClassChangedManually(true);
                            }}
                          >
                            <option value="" >Select Class</option>
                            {(classes || []).map((obj) => (
                              <option key={obj.class_id} value={obj.class_id}>{obj.class_name}</option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </div>
                    </Col>
                    <Col xs={12} md={6} lg={3} xxl={3}>
                      <div className='commonInput'>
                        <Form.Group>
                          <Form.Label>Section</Form.Label>
                          <Form.Select
                            // required
                            className="form-select"
                            id="section_id"
                            value={form.section_id}
                            onChange={handleInputChange}
                          >
                            <option value="" disabled hidden>Select Section</option>
                            {(sections || []).map((section) => (
                              <option key={section.section_id} value={section.section_id}>
                                {section.section_name}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </div>
                    </Col>
                    <Col xs={12} md={6} lg={3} xxl={3}>
                      <div className='commonInput'>
                        <Form.Group controlId="student_name">
                          <Form.Label>Adm No/Student Name<span className='requiredStar'>*</span></Form.Label>
                          <Select
                            id="student_id"
                            isClearable
                            isSearchable
                            options={students}              // this is filled by fetchStudentsByQuery
                            onInputChange={handleStudentTyping}
                            onChange={handleStudentSelect}
                            filterOption={null}             // let server filter
                            noOptionsMessage={({ inputValue }) =>
                              (inputValue?.trim()?.length ?? 0) < 3 ? "Type at least 3 characters…" : "No matches"
                            }
                          />


                        </Form.Group>
                      </div>
                    </Col>

                  </Row>
                  <Row>
                    <div >
                      <table className="receipt-table">
                        <thead>
                          <tr>
                            <th colSpan="6" className="title">FEE RECEIPT</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Date<span className='requiredStar'>*</span></td>
                            <td>
                              <input
                                required
                                type="date"
                                id="reciept_date"
                                value={form.reciept_date}
                                placeholder="Enter Receipt Date"
                                onChange={handleInputChange}

                              />
                            </td>
                            <td>Admission No</td>
                            <td>
                              <input
                                type="text"
                                id="admission_no"
                                value={form.admission_number}
                                placeholder="Enter Admission No"
                                onChange={handleInputChange}
                                readOnly
                              />
                            </td>
                            <td>Receipt No<span className='requiredStar'>*</span></td>
                            <td>
                              <input
                                type="text"
                                id="receipt_no"
                                 value={form.receipt_no}
                                placeholder="Enter Receipt Number"
                                onChange={handleInputChange}
                                readOnly
                              />
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={2}>Student Name</td>
                            <td colSpan={2}>
                              <input
                                type="text"
                                id="student_name"
                                value={form.student_name}
                                placeholder="Enter Student Name"
                                onChange={handleInputChange}
                                readOnly
                              />
                            </td>
                            <td>Class & Sec</td>
                            <td>
                              <input
                                type="text"
                                id="section_name"
                                value={form.section_name}
                                placeholder="Enter Class Name"
                                onChange={handleInputChange}
                                readOnly
                              />
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={2}>Father Name</td>
                            <td colSpan={2}>
                              <input
                                type="text"
                                id="father_name"
                                value={form.father_name}
                                placeholder="Enter Father Name"
                                onChange={handleInputChange}
                                readOnly
                              />
                            </td>
                            <td>Contact No</td>
                            <td>
                              <input
                                type="text"
                                id="contact_no"
                                value={form.contact_no}
                                placeholder="Enter Contact No"
                                onChange={handleInputChange}
                                readOnly
                              />
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={2}>Mode of Payment</td>
                            <td colSpan={2}>
                              <select
                                id="mode"
                                value={form.mode}
                                onChange={handleInputChange}
                                style={{ width: '100%', padding: '5px' }}
                                required
                              >
                                <option value="" disabled hidden>Select Mode Of Payment</option>
                                <option value="UPI">UPI</option>
                                <option value="Cash">Cash</option>
                                <option value="Cheque">Cheque</option>
                              </select>
                            </td>
                            <td>Remarks</td>
                            <td >
                              <textarea
                                id="remarks"
                                value={form.remarks}
                                placeholder="Enter Remarks"
                                onChange={handleInputChange}
                                rows={2}
                                style={{ width: "100%" }}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {studentFeeSchedule.length > 0 && (
                      <div style={{ marginTop: "5px" }}>
                        <table className="receipt-table">
                          <thead>
                            <tr>
                              <th>Schedule Name</th>
                              <th style={{ textAlign: 'right' }}>Scheduled Amount</th>
                              <th style={{ textAlign: 'right' }}>
                                Amount Paid
                                <MdInfoOutline
                                  title="View All Receipt Details"
                                  style={{
                                    marginLeft: "8px",
                                    cursor: "pointer",
                                    color: "#f6f0f1ff",
                                    verticalAlign: "middle"
                                    ,
                                    fontSize: "18px"
                                  }}
                                  onClick={() => {
                                    fetchReceiptDetails().then(() => setShowReceiptModal(true));

                                  }}
                                />
                              </th>
                              <th style={{ textAlign: 'right' }}>Balance</th>
                              <th style={{ textAlign: 'center' }}>Due Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {studentFeeSchedule.map((item, index) => {
                              const isOverdue =
                                item.balance_amount_to_be_paid > 0 &&
                                new Date(item.due_date.split("/").reverse().join("-")) < new Date();
                              return (
                                <tr key={index}>
                                  <td>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                      <span style={{ paddingLeft: "10px" }}>{item.schedule_name}</span>
                                      {Number(item.balance_amount_to_be_paid) === 0 && (
                                        <BsPatchCheckFill
                                          color="#28a745"
                                          size={18}
                                          title="Paid"
                                          style={{ animation: 'scaleIn 0.3s ease' }}
                                        />
                                      )}
                                    </div>
                                  </td>
                                  <td style={{ textAlign: 'right' }}>{item.scheduled_amount}</td>
                                  <td style={{ textAlign: 'right' }}>{item.amount_paid}</td>
                                  <td
                                    style={{
                                      textAlign: 'right',
                                      color: isOverdue ? 'red' : 'inherit',
                                      fontWeight: isOverdue ? '600' : 'normal',
                                    }}
                                  >
                                    {item.balance_amount_to_be_paid}
                                  </td>
                                  <td style={{ textAlign: 'center' }}>{item.due_date}</td>

                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                    <div style={{ marginTop: "10px", marginBottom: "10px" }}>
                      <table className="receipt-table">
                        <tbody>
                          <tr>
                            <td><strong>Total Fee</strong></td>
                            <td style={{ textAlign: 'right' }}>{discountReport[0]?.expected_fee || 0}</td>
                            <td><strong>Discount</strong></td>
                            <td style={{ textAlign: 'right' }}>{discountReport[0]?.discount || 0}</td>
                            <td><strong>Grand Total</strong></td>
                            <td style={{ textAlign: 'right' }}>{discountReport[0]?.total_fee || 0}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <FeeParticulars
                      amountDetails={receiptData.amountDetails}
                      grandTotal={receiptData.grandTotal}
                      onAmountChange={handleAmountChange}
                      studentFeeSchedule={studentFeeSchedule}
                    />

                    {studentFeeSchedule.length > 0 && (
                      <div style={{
                        marginTop: "10px",
                        textAlign: "right",
                        paddingRight: "15px",
                        fontWeight: "600",
                        fontSize: "16px"
                      }}>
                        Total Balance Due: ₹ {studentFeeSchedule.reduce(
                          (sum, item) => sum + (parseFloat(item.balance_amount_to_be_paid) || 0),
                          0
                        ).toFixed(2)}
                      </div>
                    )}

                  </Row>
                  <div className="d-flex justify-content-between mt-3">
                    <div>
                      <Button
                        type="button"
                        variant="primary"
                        className="btn-info clearBtn"
                        onClick={() => {
                          setReceiptData((prevData) => ({
                            ...prevData,
                            amountDetails: [],
                            grandTotal: 0,
                          }));
                          setForm({
                            class_id: null,
                            class_name: "",
                            student_id: "",
                            student_name: "",
                            section_id: "",
                            reciept_date: "",
                            admission_number: "",
                            receipt_no: "",
                            father_name: "",
                            mode: "",
                            transation_no: "",
                            fee_schedule_id: "",
                            schedule_name: "",
                            section_name: "",
                            contact_no: "",
                            remarks: "",
                          })
                        }}
                        disabled={isSubmitting}
                      >
                        Reset
                      </Button>
                    </div>
                    <div>
                      <Button
                        type="button"
                        variant="primary"
                        className="btn-danger secondaryBtn me-2"
                        onClick={() => window.history.back()}
                        disabled={isSubmitting}
                      >
                        Cancel
                      </Button>
                      {canWrite && (
                        <Button
                          type="submit"
                          variant="primary"
                          className="btn-success primaryBtn"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <>
                              <Spinner as="span" animation="border" size="sm" className="me-2" />
                              Processing…
                            </>
                          ) : (
                            "Submit and Print"
                          )}
                        </Button>
                      )}
                    </div>
                  </div>
                </form>
              </Card.Body>
              <Modal
                show={showReceiptModal}
                onHide={() => setShowReceiptModal(false)}
                size="xl"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>Receipt Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <DataTable
                    columns={receiptColumns}
                    data={receiptDetails}
                    noHeader
                    dense
                    className="custom-table"
                    highlightOnHover
                  />
                </Modal.Body>
              </Modal>
            </Card>
          </Container>
        </div>
   
  
  )
}

export default AddFeeReceipts